const Colors = {
    background: '#FAFAFA',
    white: '#fff',
    clear: 'rgba(0,0,0,0)',
    transparent: 'rgba(0,0,0,0)',
    silver: '#cfcfcf',
    cloud: 'rgba(200,200,200, 0.35)',
    dark: '#000000',
    windowTint: 'rgba(0, 0, 0, 0.4)',
    panther: '#161616',
    charcoal: '#595959',
    coal: '#2d2d2d',
    darkBlue: '#12243F',
    primary: '#1D4289',
    lightBlue: '#10206C',
    lightGreen: '#02b902a3',
    lightRed: '#ff0000bf',
    lightYellow: '#ffff00a8',
    lightGrey: '#808080a6',
};

export default Colors;
